import NewDesign from 'components/NewDesign';
import React from 'react';
import Props from '../../Components/Props';
import JSXCode from '../../Components/JSXCode';
import { Separator } from 'shadcn/components/separator';
import { TooltipReactTooltip } from 'components/Tooltip';

const TabTooltip = () => {
  return (
    <div className='component:TabTooltip'>
      <NewDesign.Tooltip message='This is tooltip' />

      <div className='tw-mt-3'>
        <JSXCode code={`<NewDesign.Tooltip message='This is tooltip' />`} />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'message',
            type: 'JSX | string',
            default: 'undefined',
          },
          {
            prop: 'className',
            type: 'string',
            default: 'undefined',
          },
        ]}
      />

      <Separator className='tw-my-10' />

      <div>
        <TooltipReactTooltip messageToolTip='Taddaaaa...'>
          Hover and tooltip will show
        </TooltipReactTooltip>
      </div>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<TooltipReactTooltip messageToolTip='Taddaaaa...'>
          Hover and tooltip will show
</TooltipReactTooltip>`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'children',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'messageToolTip',
            type: 'JSX | string',
            default: 'undefined',
          },
          {
            prop: 'v2Options',
            type: '{"side": "top" | "right" | "bottom" | "left"}',
            default: 'undefined',
          },
        ]}
      />
    </div>
  );
};

export default TabTooltip;
